import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Contact from "../../components/home/Contact";
import Event from "../../components/home/Event";
import Partners from "../../components/home/Partners";
import Service from "../../components/home/Service";

const Transform = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.result === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Danggeun Market conversion (문의 접수)
    (window as any).karrotPixel?.track("Lead");
  }, []);

  return (
    <div>
      <div className=" relative w-full h-fit">
        <img
          className="hidden lg:block absolute right-0 w-full h-[calc(100%+6rem)] 2xl:h-[calc(100%+7rem)] -top-24 2xl:-top-28"
          alt=""
          aria-hidden="true"
          src="/images/bannerBg.png"
        ></img>
        <Banner />
      </div>
      <Event />
      <About />
      <Service />
      <Blog data={data} />
      <Contact />
      <Partners />
    </div>
  );
};

export default Transform;
